import { Params } from '@angular/router';

/**
 * Takes a path segment and extracts the query parameters from it.
 * Returns the stripped path as well as the extracted query parameters.
 * Paths that don't contain any query parameters will be left unchanged.
 *
 * @param path the path to extract the query parameters from
 */
export function extractQueryParams(path: string): { path: string; queryParams: Params } {
  const searchStart = path.indexOf('?');
  if (searchStart < 0) {
    return { path, queryParams: {} };
  }

  const strippedPath = path.substr(0, searchStart);
  const params: Params = {};
  const queryParams = new URLSearchParams(path.substr(searchStart));
  queryParams.forEach((value, key) => (params[key] = value));
  return { path: strippedPath, queryParams: params };
}
